import { createFileRoute } from '@tanstack/react-router';
import { Page } from '@trukt/ui/Page';
import OrderCreate from '../order/create/OrderCreate';

const Component = () => <Page route={{ title: 'Create Order', Component: OrderCreate }} />;

export const Route = createFileRoute('/order/create')({ component: Component });
